fx.ns("shared.screens", class RemotePhotoEffectWaiting extends fx.Component{
    
	constructor()
	{
		super();

		this.showEffect = "hslideout";
		this.hideEffect = "hslidein";

		this.destroyOnSwitch = true;
	}

     get personBox()
    {
        return this._personBox;
    }

    get container()
    {
        return this._container;
    }

    get title()
    {
	    if (this.initialized)
			return this._titleComponent.text;
    }

    set title(val)
    {
		if (this.initialized)
			this._titleComponent.text = val;
    }


    create()
    {
        super.create();

        // -------------// 
        this._container = new fx.components.Box("container");

		this._personBox = new shared.component.Person(fx.get("assets").splashPhoto);

        this.container.addChild(this._personBox, {width:260, height : 260, top : 0, left : "center"});


		this._titleComponent = new fx.components.Text({ className : "title"});
		//this._textComponent = new fx.components.Text({text : fx.text(this.subtitle), className : "text"});

		this.container.addChild(this._titleComponent, {width:"100%", height : 40, top : 280, left : "center"});

        this.progressBar = new fx.components.ProgressBar({showLabel:false});
        this.progressBar.effect = "scale";
        this.container.addChild(this.progressBar, {width:"100%", height:50, top:340});
		//this.container.addChild(this._textComponent, {width:"100%", height : 30, top : 330, left : "center"});

		this.addChild(this.container, { width : "100%", height : 400, top : "center", left : "center"});
        // ----------- //

        this.iconCheck = new fx.components.Image({data: fx.get("assets").checkedIcon, className : "finished"});
        this.iconCheck.visibleAtStart = false;
        this.iconCheck.effect = "scale";
        this.container.addChild(this.iconCheck, {width:60, height : 60, top : 330, left : "center"});

        this.personBox.spinning = true;

        this.starIcon1 = new fx.components.Image({data:fx.assets.starIcon, className : "star star1"});
        this.starIcon2 = new fx.components.Image({data:fx.assets.starIcon, className : "star star2"});
        this.starIcon3 = new fx.components.Image({data:fx.assets.starIcon, className : "star star3"});
        this.starIcon4 = new fx.components.Image({data:fx.assets.starIcon, className : "star star4"});
        this.starIcon5 = new fx.components.Image({data:fx.assets.starIcon, className : "star star5"});

        this.starIcon1.visibleAtStart = false;
        this.starIcon2.visibleAtStart = false;
        this.starIcon3.visibleAtStart = false;
        this.starIcon4.visibleAtStart = false;
        this.starIcon5.visibleAtStart = false;

        this.personBox.addChild(this.starIcon1, {width:50, height : 50, top : 80, left : 0});
        this.personBox.addChild(this.starIcon2, {width:50, height : 50, top : 15, left : 45});
        this.personBox.addChild(this.starIcon3, {width:50, height : 50, top : 10, left : 160});
        this.personBox.addChild(this.starIcon4, {width:50, height : 50, top : 90, left : 210});
        this.personBox.addChild(this.starIcon5, {width:50, height : 50, top : 0, left : 100});
    }

	onReady()
	{
		super.onReady();

         // 40 seconds is the average time to wait for Gemini, 100 for remove background
        this.averageDelay = this.data.creation.filteredPhoto.content_type != "remove-background" ? 500 : 200;

        if (!this.data.photos.processing)
            this._step5();
        else
        {
            if (this._updatePhoto())
                this.delay(this._step1, 1000);
            else
                this.title = fx.text("Un peu de magie...");
        }
            

        //this.delay(this._step5, 15000);

        this.repeat(this._updateProgress, 100);
        this._start = 0;
	}

    _updatePhoto() 
    {
        let photo = this.data.photos.last;

        if (photo && !photo.initializing)
        {
            if (photo.light_url)
                this.personBox.src = photo.light_url;

            return true;
        }

        return false;
    }

    _updateProgress()
    {
        this.progressBar.update(this._start,this.averageDelay);

        this._start++;
    }
   
    onChildUpdated(action)
    {
        if (action.model instanceof models.Photo)
        {
            if (!action.model.initializing)
            {
                this._updatePhoto();
                this.delay(this._step1, 1000);
            }
                
            if (!action.model.processing)
                this._step5();
        }
            
    }

	_step1()
    {
        let photo = this.data.photos.last;
        if (photo.isTemporary)
            this.title = fx.text("Super photo, félicitations !");
        else
            this.title = fx.text("Sublimation en cours !");
        

        this.delay(this._step2, photo.isTemporary ? 4000 : 5000);
    }

    _step2()
    {
        if (!this.data.photos.processing) return;

        //this.personBox.src = fx.get("assets").personNice;
        this.title = fx.text("Un peu de magie...");

        this.delay(this._step3, 5000);
    }

     _step3()
    {
        if (!this.data.photos.processing) return;

        let photo = this.data.photos.last;
        //if (this.data.photos.length > 1)
        //    this.title = fx.text("J'isole les personnages...");
        //else
            if (photo.isTemporary)
                this.title = fx.text("Je crée votre poster...");
            else
                this.title = fx.text("Votre photo se transforme...");

        //this.personBox.src = fx.get("assets").personHappy;

        this.delay(this._step4, 5000);
    }

    _step4()
    {
        if (!this.data.photos.processing) return;
        
        //this.personBox.src = fx.get("assets").personThinking;
        this.title = fx.text("On y est presque...");

        this.delay(this._step2, 5000);
    }

    // ---- Finished --- //
     _step5()
    {
        this.starIcon1.hide();
        this.starIcon2.hide();
        this.starIcon3.hide();
        this.starIcon4.hide();
        this.starIcon5.hide();
        this.progressBar.hide();

        this.iconCheck.show();
        this.personBox.src = fx.get("assets").personSure;
        this.title = fx.text("C'est prêt !");

        this.delay(this._step6, 1000);
    }

     _step6()
     {
        if (fx.get("app") == "config")
            this.data.event("filtering-photo-finished");
        else
        {
            if (fx.get("mode") == "creating")
                this.data.event("step-PosterEditor");
            else
                this.data.event("show-editor");
        }
     }

});

	